import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, IntegerDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { Product } from "./Product";
export class Category extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        this.priority = 0;
        this.products = [];
    }
    apply(priceList) {
        const clone = this.patch({});
        clone.products = this.products.map(p => p.apply(priceList));
        return clone;
    }
    static applyAll(categories, priceList) {
        return categories.map(c => c.apply(priceList));
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Category.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Category.prototype, "name", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Category.prototype, "priority", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Product) })
], Category.prototype, "products", void 0);
//# sourceMappingURL=Category.js.map